// namespace Pacem.Mathematics {
function complex(c) {
    if (typeof c === 'number') {
        c = { real: c, img: 0 };
    }
    return c;
}
var NOT_A_COMPLEX;
function buildComplex(real, img) {
    const c = {};
    Object.defineProperty(c, 'real', { value: real, writable: false });
    Object.defineProperty(c, 'img', { value: img, writable: false });
    return c;
}
function nac() {
    return NOT_A_COMPLEX || (NOT_A_COMPLEX = buildComplex(Number.NaN, Number.NaN));
}
export class Complex {
    static build(real, img) {
        if (this.isComplex(real)) {
            return real;
        }
        img ??= 0;
        if (typeof real != 'number' || typeof img != 'number') {
            return nac();
        }
        return buildComplex(real, img || 0);
    }
    static add(a, b) {
        const ac = complex(a), bc = complex(b);
        return buildComplex(ac.real + bc.real, ac.img + bc.img);
    }
    static subtract(from, what) {
        const ac = complex(from), bc = complex(what);
        return buildComplex(ac.real - bc.real, ac.img - bc.img);
    }
    static multiply(a, b) {
        const ac = complex(a), bc = complex(b);
        return buildComplex(
        /* real*/ ac.real * bc.real - ac.img * bc.img, 
        /* img */ ac.real * bc.img + ac.img * bc.real);
    }
    static divide(a, b) {
        const ac = complex(a), bc = complex(b);
        const div = this.absSquare(bc).roundoff();
        if (div === 0) {
            return nac();
        }
        const inv_div = 1 / div;
        return buildComplex(
        /* real*/ inv_div * (ac.real * bc.real + ac.img * bc.img), 
        /* img */ inv_div * (ac.img * bc.real - ac.real * bc.img));
    }
    static absSquare(c) {
        const ac = complex(c);
        return Math.pow(ac.real, 2) + Math.pow(ac.img, 2);
    }
    static modulus(c) {
        return Math.sqrt(this.absSquare(c));
    }
    static isComplex(c) {
        return c != null && typeof c === 'object' && 'real' in c && 'img' in c && typeof c.real === 'number' && typeof c.img === 'number';
    }
    static conjugate(a) {
        a = complex(a);
        return buildComplex(a.real, Math.abs(a.img) == 0 ? 0 : -a.img);
    }
    static equals(c1, c2) {
        const c_1 = this.build(c1), c_2 = this.build(c2);
        if (!this.isComplex(c1) || !this.isComplex(c2)) {
            return false;
        }
        return c_1.real === c_2.real && c_1.img === c_2.img;
    }
    //static isNaN(c: Complex | number): boolean {
    //    switch (c) {
    //        case undefined:
    //            // doh!
    //            return true;
    //        case null:
    //            // doh!
    //            return false;
    //        default:
    //            if (!this.isComplex(  c)
    //    }
    //}
    static get NaC() { return nac(); }
}
//}
